// Public-only locales share the same homepage prose across brands; only the
// brand name is substituted by the brand-resource loader.
export const brandMarketingCopy: Record<string, Record<string, string>> = {
  cs: {
    tagline: "Nadčasová auta, nekonečná dobrodružství",
    hero_subtitle: "Užijte si jízdu v klasických a ikonických autech.",
    unlock_title: "Využijte potenciál svého auta",
    unlock_description: "Vaše klasické auto vám může přinášet příjem a my jsme to usnadnili. Nabídnout auto na {{brandName}} ale neznamená jen vydělávat — znamená to sdílet svou vášeň.",
  },
  pl: {
    tagline: "Ponadczasowe auta, niekończące się przygody",
    hero_subtitle: "Ciesz się jazdą klasycznymi i kultowymi samochodami.",
    unlock_title: "Wykorzystaj potencjał swojego samochodu",
    unlock_description: "Twój klasyczny samochód może przynosić Ci dochód, a my to ułatwiamy. Udostępnianie auta na {{brandName}} to jednak nie tylko zarabianie — to dzielenie się swoją pasją.",
  },
  sk: {
    tagline: "Nadčasové autá, nekonečné dobrodružstvá",
    hero_subtitle: "Užite si jazdu v klasických a ikonických autách.",
    unlock_title: "Využite potenciál svojho auta",
    unlock_description: "Vaše klasické auto vám môže prinášať príjem a my sme to uľahčili. Ponúknuť auto na {{brandName}} však neznamená len zarábať — znamená to deliť sa o svoju vášeň.",
  },
  bg: {
    tagline: "Непреходни автомобили, безкрайни приключения",
    hero_subtitle: "Насладете се на пътуването с класически и емблематични автомобили.",
    unlock_title: "Разкрийте потенциала на автомобила си",
    unlock_description: "Вашият класически автомобил може да ви носи доходи, а ние направихме това лесно. Но да предложите автомобила си в {{brandName}} не е само начин да печелите — това е начин да споделите страстта си.",
  },
  fi: {
    tagline: "Ajattomia autoja, loputtomia seikkailuja",
    hero_subtitle: "Nauti ajamisesta klassisilla ja ikonisilla autoilla.",
    unlock_title: "Hyödynnä autosi mahdollisuudet",
    unlock_description: "Klassikkoautosi voi tuoda sinulle tuloja, ja olemme tehneet siitä helppoa. Auton tarjoaminen {{brandName}}-palvelussa ei kuitenkaan ole vain ansaitsemista — se on oman intohimosi jakamista.",
  },
  "pt-BR": {
    tagline: "Carros atemporais, aventuras sem fim",
    hero_subtitle: "Aproveite o passeio com carros clássicos e icônicos.",
    unlock_title: "Aproveite o potencial do seu carro",
    unlock_description: "Seu carro clássico pode gerar renda, e nós facilitamos isso. Mas anunciar seu carro na {{brandName}} não é apenas ganhar dinheiro — é compartilhar sua paixão.",
  },
};
